import { ListViewModelImpl } from '../../../../toolkit/horizontallist/listviewmodel';
import { BaseContext } from '../../../../../utils/basecontext';
import * as React from 'react';
import { MyTonesCardComponent } from './mytonescard/mytonescardcomponent';
import { ListTonesDto } from '../../../../../core/dto/listtones/listtonesdto';
import { MyTonesCardCSSStyle, MyTonesCardCSSStyleImpl } from './mytonescard/mytonescardcss';
import { MyTonesEvenCardCSSStyleImpl } from './mytonescard/mytonesevencardcss';

export class ListTonesViewModelImpl extends ListViewModelImpl<ListTonesDto>
{
    protected oddCSSStyle:MyTonesCardCSSStyle;
    protected evenCSSStyle:MyTonesCardCSSStyle;
    constructor(context: BaseContext, private onDelete: any)
    {
        super(context);

        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.oddCSSStyle = new MyTonesCardCSSStyleImpl(context);
        this.evenCSSStyle = new MyTonesEvenCardCSSStyleImpl(context);
    }

    getOffset(): number
    {
        return 5;
    }

    getView(t: ListTonesDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
        return <MyTonesCardComponent cssStyle={this.oddCSSStyle} onDeleteClicked={this.onDeleteClicked} key={position} context={this.getContext()} playingMyTunesdto={t}  position={position}/>;
        }
        else
        {
            return <MyTonesCardComponent cssStyle={this.evenCSSStyle} onDeleteClicked={this.onDeleteClicked} key={position} context={this.getContext()} playingMyTunesdto={t}  position={position}/>;

        }
    }

    onDeleteClicked(toneDto: ListTonesDto): void 
    {
      this.onDelete(toneDto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/listtoneviewmodel.tsx